import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'projects/evolutics-shared-lib/src/environments/environment';
import { ELanguage } from 'ets-fe-ng-sdk';
import { UtilityService } from '../utility.service';

@Injectable()
export class AuthenticationInterceptorService implements HttpInterceptor {
  readonly uS = inject(UtilityService);
  constructor(public router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // req.url
    //  debugger;
    if (
      environment.authenticate &&
      (req.url.startsWith(environment.apiBaseUrl) ||
        req.url.startsWith(environment.coreBaseUrl) ||
        req.url.startsWith(environment.processMapBaseURL) ||
        req.url.startsWith(environment.messagingBaseURL) ||
        req.url.startsWith(environment.jupiterWorkflowAPIURL) ||
        req.url.startsWith(environment.jupiterMessagingBaseURL) ||
        req.url.startsWith(environment.gatewayBaseURL))
    ) {
      const reqAuth = req.clone({
        url: req.url,
        headers: this.uS.setHeaders(req.headers, {
          Authorization: environment.token,
          userCompanyCode: environment.userProfile?.users.primaryCompany || environment.webUser?.companyCode,
          language: req.headers.has('skipLanguage')
            ? ''
            : environment.userProfile?.users.language || ELanguage.EN,
        }),
        withCredentials:
          environment.useAuthCookies &&
          req.method?.toUpperCase() != 'DELETE' &&
          req.method?.toUpperCase() != 'PUT',
      });
      return next.handle(reqAuth).pipe(
        catchError((event: HttpEvent<any>) => {
          if (event instanceof HttpErrorResponse && event.status == 401) {
            if (
              environment.token &&
              (event.url.startsWith(environment.processMapBaseURL) ||
                event.url.startsWith(
                  environment.useGatewayMS ? environment.gatewayBaseURL : environment.apiBaseUrl,
                ))
            ) {
              // debugger;
              console.error(`About to be loggeed out due to 401 `, event, req);
              // this.authS.logout();
              // location.href = '/login';
              this.router.navigate(['/login'], { queryParams: { r: location.href } });
            }
          }
          if (event instanceof TypeError) console.error(event);
          throw event;
        }),
      );
    } else return next.handle(req);
  }
}
